import { MotionReveal } from "../../components/MotionReveal";

export default function DefenceIndustryPage() {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="pt-6 sm:pt-10">
        <MotionReveal>
          <div className="glass-panel rounded-3xl p-8 sm:p-10">
            <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs uppercase tracking-[0.18em] text-[var(--text-secondary)]">
              Defence & Critical Infrastructure
            </div>
            <h1 className="mt-6 font-[var(--font-display)] text-4xl sm:text-5xl tracking-tight text-white">
              Defence AIOps & Observability
            </h1>
            <p className="mt-4 max-w-3xl text-sm sm:text-base text-[var(--text-secondary)]">
              Mission assurance through operational resilience.
            </p>
            <div className="mt-8 grid gap-4 lg:grid-cols-2">
              <div className="rounded-3xl border border-white/10 bg-white/3 p-6">
                <div className="text-xs uppercase tracking-[0.22em] text-[var(--text-secondary)]">Challenge</div>
                <div className="mt-3 grid gap-2 text-sm text-[var(--text-secondary)]">
                  <div>Zero failure tolerance for mission-critical systems</div>
                  <div>Air-gapped / hybrid environments</div>
                  <div>Converged IT/OT monitoring needs</div>
                  <div>Data sovereignty and classification constraints</div>
                </div>
              </div>
              <div className="rounded-3xl border border-white/10 bg-white/3 p-6">
                <div className="text-xs uppercase tracking-[0.22em] text-[var(--text-secondary)]">Outcomes</div>
                <div className="mt-3 grid gap-2 text-sm text-[var(--text-secondary)]">
                  <div>✓ Mission assurance</div>
                  <div>✓ Operational resilience</div>
                  <div>✓ Reduced human dependency</div>
                  <div>✓ Audit compliance</div>
                </div>
              </div>
            </div>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center rounded-xl px-5 py-3 text-sm font-medium text-[#061019] bg-[var(--accent-primary)] hover:brightness-110"
              >
                Request Defence Assessment
              </a>
              <a
                href="/technology-stack"
                className="inline-flex items-center justify-center rounded-xl px-5 py-3 text-sm font-medium text-white border border-white/15 bg-white/5 hover:bg-white/8"
              >
                View Technology Stack
              </a>
            </div>
          </div>
        </MotionReveal>
      </div>
      <div className="h-12" />
    </div>
  );
}
